import { ActionButton, SplitButtonActionItem } from '@components/button/types'
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { SxProps } from '@mui/material/styles'
import { useT } from '@transifex/react'
import { flatten, map as mapFp } from 'lodash/fp'
import { useState } from 'react'
import { Link } from 'react-router'
import MoreActionsMenuContent from './MoreActionsMenuContent'

type MoreActionsMenuProps = {
  actions: ActionButton[]
  buttonStyle?: SxProps
}

const MoreActionsMenu: React.FC<MoreActionsMenuProps> = ({ actions, buttonStyle }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const t = useT()

  const visibleActions = actions.filter(action =>
    action.visible === undefined ? true : action.visible,
  )
  if (visibleActions.length === 0) return null

  const regularButtonActions = visibleActions.filter(
    action => action.type !== 'split' && action.type !== 'dropdown',
  )
  const splitButtons = visibleActions.filter(action => action.type === 'split')
  const splitButtonsActions = flatten(mapFp('actions', splitButtons))
  const dropdownButtons = visibleActions.filter(action => action.type === 'dropdown')
  const dropdownButtonsActions = flatten(mapFp('actions', dropdownButtons))
  const allVisibleActions: (SplitButtonActionItem | ActionButton)[] = [
    ...regularButtonActions,
    ...splitButtonsActions,
    ...dropdownButtonsActions,
  ]

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <Button
        id="btnMoreActionButtons"
        aria-label={t('More action buttons')}
        onClick={handleClick}
        sx={buttonStyle}>
        <MoreVertOutlinedIcon />
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          sx: {
            '& .MuiMenuItem-root': {
              minWidth: 150,
            },
          },
        }}>
        {allVisibleActions.map(action =>
          !!action.to ? (
            <MenuItem
              sx={{ color: (action as ActionButton).color ?? 'inherit' }}
              id={`menuItem-${action.key}`}
              key={action.key}
              component={Link}
              onClick={handleClose}
              to={action.to!}
              disabled={action.disabled}>
              <MoreActionsMenuContent action={action} />
            </MenuItem>
          ) : (
            <MenuItem
              sx={{
                color: (action as ActionButton).color ?? 'inherit',
              }}
              id={`menuItem-${action.key}`}
              key={action.key}
              onClick={(event: React.MouseEvent) => {
                if (action.onClick) {
                  action.onClick(event)
                }
                handleClose()
              }}
              disabled={action.disabled}>
              <MoreActionsMenuContent action={action} />
            </MenuItem>
          ),
        )}
      </Menu>
    </>
  )
}

export default MoreActionsMenu
